(function($) {
  $.summerfall = {
    intervals: [],
    $wrapper: null,

    start: function(options, $wrapper) {
      var settings = $.extend(true, {}, {
        size: {
          min: 26,
          max: 42
        },
        interval: 1100,
        mobileInterval: 1600,
        color: '#FFC300',
        content: '&#9728;',
        disappear: 'linear',
        initialBurst: 4
      }, options);

      var isDesktop = window.matchMedia("(min-width: 720px)").matches;

      if ($wrapper == undefined || !$wrapper.length) {
        if (!$('#summerfall-wrapper').length) {
          $('body').append('<div id="summerfall-wrapper" />');
        }

        $wrapper = $('#summerfall-wrapper');

        $wrapper.css({
          'overflow': 'hidden',
          'height': '100vh',
          'width': '100%',
          'position': 'fixed',
          'top': '0',
          'left': '0',
          'z-index': '10',
          'pointer-events': 'none'
        });
      }

      var $sun = $('<div class="summer-sun" />')
        .css({
          'position': 'absolute',
          'top': '-15px',
          'line-height': '1',
          'will-change': 'transform, opacity',
          'text-shadow': '0 0 8px rgba(255, 195, 0, 0.65), 0 0 16px rgba(255, 195, 0, 0.35)'
        })
        .html(settings.content);

      $.summerfall.$wrapper = $wrapper;
      $.summerfall.$wrapper.show();

function createSun() {
  var wrapperWidth = $wrapper.width(),
      wrapperHeight = $wrapper.height(),
      sunSize = settings.size.min + (Math.random() * (settings.size.max - settings.size.min)),
      duration = isDesktop ? 11000 + (Math.random() * 5000) : 13000 + (Math.random() * 6000),
      startPosition = Math.random() * wrapperWidth,
      drift = -90 + (Math.random() * 180),
      startOpacity = isDesktop ? 1 : 0.9,
      endOpacity = isDesktop ? 0.78 : 0.62,
      rotation = -20 + (Math.random() * 40);

  $sun.clone().appendTo($wrapper).css({
    'left': startPosition,
    'opacity': startOpacity,
    'font-size': sunSize,
    'color': settings.color,
    'transform': 'translateY(0) rotate(' + rotation + 'deg)'
  }).animate({
    top: wrapperHeight + 40,
    left: startPosition + drift,
    opacity: endOpacity
  }, duration, settings.disappear, function() {
    $(this).remove();
  });
}

      for (var i = 0; i < settings.initialBurst; i++) {
        setTimeout(createSun, i * 250);
      }

      var currentInterval = isDesktop ? settings.interval : settings.mobileInterval;

      $.summerfall.intervals.push(setInterval(function() {
        createSun();
      }, currentInterval));
    },

    stop: function() {
      $.summerfall.intervals.forEach(function(interval) {
        clearInterval(interval);
      });

      $.summerfall.intervals = [];

      if ($.summerfall.$wrapper) {
        $.summerfall.$wrapper.hide();
        $.summerfall.$wrapper.children('div').remove();
      }
    }
  };
})(jQuery);